import { render, staticRenderFns } from "./ChangeQuestionView.vue?vue&type=template&id=5fd943af&scoped=true"
import script from "./ChangeQuestionView.vue?vue&type=script&lang=js"
export * from "./ChangeQuestionView.vue?vue&type=script&lang=js"
import style0 from "./ChangeQuestionView.vue?vue&type=style&index=0&id=5fd943af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd943af",
  null
  
)

export default component.exports